
import React from "react";

type Props = {
  title?: string;
  canEdit: boolean;
  onCreate: () => void;
  onExport: () => void;
  onImport?: () => void;
  extraButtons?: React.ReactNode;
};

export function DataToolbar({ title, canEdit, onCreate, onExport, onImport, extraButtons }: Props) {
  return (
    <div className="row" style={{ marginBottom: 16, justifyContent: "space-between", alignItems: "center" }}>
      {title && <div style={{ fontSize: 14, fontWeight: "bold", color: "var(--muted)" }}>{title}</div>}
      <div className="row" style={{ marginLeft: "auto", gap: 8 }}>
        {extraButtons}
        
        {/* Only show actions if canEdit is true */}
        {canEdit && (
          <>
            <button 
              className="smallbtn" 
              onClick={onCreate}
              style={{ background: "#fff", color: "#000", fontWeight: "bold" }}
            >
              ＋ 新增資料
            </button>

            {onImport && (
              <button className="smallbtn" onClick={onImport} style={{background: 'rgba(255,255,255,0.1)', border: '1px solid #666', color: '#fff'}}>
                📥 匯入
              </button>
            )}

            <button className="smallbtn" onClick={onExport} title="匯出 Excel/CSV">
              📤 匯出
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export function ActionButtons({ canEdit, onEdit, onDelete, onPreview }: { canEdit: boolean, onEdit: () => void, onDelete: () => void, onPreview: () => void }) {
  return (
    <div className="row" style={{ gap: 6, justifyContent: 'flex-end' }}>
      <button className="smallbtn" style={{ padding: "4px 8px", fontSize: 12 }} onClick={onPreview}>預覽</button>
      {canEdit && (
        <>
          <button className="smallbtn" style={{ padding: "4px 8px", fontSize: 12 }} onClick={onEdit}>修改</button>
          <button 
            className="smallbtn" 
            style={{ padding: "4px 8px", fontSize: 12, color: "var(--danger)", borderColor: "var(--danger)", background: "rgba(255,93,108,0.1)" }} 
            onClick={onDelete}
          >
            刪除
          </button>
        </>
      )}
    </div>
  );
}
